<template>
  <div
    class="bg-white border border-gray-200 rounded-lg dark:bg-gray-800 dark:border-gray-700"
  >
    <div
      v-if="title"
      class="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700"
    >
      <h6 class="text-sm font-semibold text-gray-900 dark:text-white">
        {{ title }}
      </h6>
      <slot name="header-action" />
    </div>
    <div class="p-4">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  title?: string;
}>();
</script>
